// extracted by mini-css-extract-plugin
export default {"table-wrapper":"Patient_table-wrapper__lS9lU","btn":"Patient_btn__2dK-e","btnStyles":"Patient_btnStyles__Hagr1"};